// Seu perfil (tela 7.1): no topo, o mesmo do perfil público, com Editar perfil e Compartilhar perfil no lugar dos
// botões de amizade e trio; embaixo, o que é só seu: divisão, badges com o que falta, coleção, passe, trios, editar
// rosto e apelido, gritos, a chave do WhatsApp, sair e excluir a conta (LGPD).
// No fim, a lista da conta e do jogo (canvas F15b): CONTA com Meu plano (Planos, no Grátis), Indique e ganhe e Tentos;
// JOGO com Como jogar, Trios fixos, o Marcador e Configurações; e Termos e privacidade. A engrenagem também leva a Configurações.
import { SeloNoTopo } from '../comum/SeloGratis.tsx';
import { useEffect, useState } from 'react';
import { BONUS_POR_INDICACAO, NOME_DO_PLANO, precoEmReais } from '@truco6/planos';
import type { PainelTrios } from '@truco6/gamificacao';
import { type PainelLiga, avisarPerfilCompleto, lerLiga, lerTrios } from '../comum/api.ts';
import { conta, type PerfilConta, type Sessao } from '../comum/conta.ts';
import { medir } from '../comum/medicao.ts';
import { ir } from '../comum/rotas.ts';
import { BadgesDoPerfil } from '../liga/badges.tsx';
import { ColecaoNoPerfil } from '../liga/colecao.tsx';
import { PasseNoPerfil } from '../liga/passe.tsx';
import { OfensivaDoPerfil } from '../liga/ofensiva.tsx';
import { NivelDoPerfil } from '../liga/rodagem.tsx';
import { BarraDivisao } from '../liga/comum.tsx';
import { Escudo } from '../liga/trios.tsx';
import { FormPerfil } from './FormPerfil.tsx';
import { Gritos } from './Gritos.tsx';
import { Icone, Moeda } from './planos-comum.tsx';
import { Tento, usePainelTentos } from './tentos-comum.tsx';
import { ChaveWhatsapp } from '../comum/Whatsapp.tsx';
import { avisarNaTela } from '../comum/aviso.tsx';
import { ConteudoDoPerfil } from './PerfilPublico.tsx';
import { Tela, Topo } from './comum.tsx';

// Divisão da liga com a barra de PD e os pontos da temporada (na virada, os pontos zeram e a divisão fica).
function DivisaoDoPerfil({ sessao }: { sessao: Sessao }) {
  const [p, setP] = useState<PainelLiga | null>(null);
  useEffect(() => { let vivo = true; void lerLiga(sessao).then((x) => { if (vivo) setP(x); }, () => {}); return () => { vivo = false; }; }, [sessao.id]);
  if (!p) return null;
  return (
    <>
    {p.rodagem && <NivelDoPerfil n={p.rodagem} />}
    {p.ofensiva && <OfensivaDoPerfil o={p.ofensiva} />}
    <section className="cartao divisao-perfil" aria-label="Sua divisão">
      <BarraDivisao d={p.divisao} />
      <p className="nota"><b>{p.pontos.temporada}</b> pts na temporada · <b>{p.pontos.semana}</b> nesta semana</p>
      <button className="link" onClick={() => ir({ tela: 'ranking' })}>Ver ranking</button>
    </section>
    </>
  );
}

// Seus trios fixos: no Ouro, todos aparecem no perfil; nos outros planos, o primeiro, com o atalho para os outros.
function TriosDoPerfil({ sessao }: { sessao: Sessao }) {
  const [p, setP] = useState<PainelTrios | null>(null);
  useEffect(() => { let vivo = true; void lerTrios(sessao).then((x) => { if (vivo) setP(x); }, () => {}); return () => { vivo = false; }; }, [sessao.id]);
  if (!p) return null;
  const mostrar = p.todosNoPerfil ? p.trios : p.trios.slice(0, 1);
  return (
    <section className="cartao trios-perfil" aria-label="Seus trios fixos">
      <b className="rotulo">Trios fixos</b>
      {mostrar.map((t) => (
        <button key={t.id} className="linha-trio-perfil" onClick={() => ir({ tela: 'trio', id: t.id })}>
          <Escudo id={t.escudo} tamanho={32} /><span>{t.nome}</span>{!t.ativo && <small className="etiqueta guardado">Guardado</small>}
        </button>
      ))}
      {!p.trios.length && <p className="nota">Você ainda não está em um trio fixo.</p>}
      <button className="link" onClick={() => ir({ tela: 'trios' })}>{p.trios.length > mostrar.length ? `Ver os ${p.trios.length} trios` : 'Ver trios'}</button>
    </section>
  );
}

export function PerfilTela({ sessao, perfil, aoSalvar, campo }: {
  sessao: Sessao; perfil: PerfilConta; aoSalvar: (p: PerfilConta) => void; campo?: 'cidade';
}) {
  const [ocupado, setOcupado] = useState(false);
  // ESCOLHER CIDADE (ranking sem cidade, Configurações): abre direto no campo da cidade.
  useEffect(() => {
    if (campo !== 'cidade') return;
    const t = setTimeout(() => {
      const c = document.querySelector<HTMLInputElement>('#editar-perfil [role="combobox"]');
      c?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      c?.focus({ preventScroll: true });
    }, 150);
    return () => clearTimeout(t);
  }, [campo]);
  const [msg, setMsg] = useState<string | null>(null);
  const [confirmar, setConfirmar] = useState<'sair' | 'excluir' | null>(null);
  const [erro, setErro] = useState<string | null>(null);

  async function acao(fn: () => Promise<void>) {
    setErro(null);
    try { await fn(); ir({ tela: 'inicio' }, true); } catch (e) { setErro((e as Error).message); }
  }

  return (
    <Tela painel>
      <SeloNoTopo />
      <div className="painel-perfil">
      <div className="perfil-lado">
      <div className="topo-com-acao">
        <Topo titulo="Seu perfil" />
        <button className="engrenagem" aria-label="Configurações" onClick={() => ir({ tela: 'configuracoes' })}>
          <svg width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
          </svg>
        </button>
      </div>
      <ConteudoDoPerfil sessao={sessao} usuario={sessao.id} proprio extras={<AcoesDoSeuPerfil sessao={sessao} />} />
      </div>
      <div className="perfil-cartoes">
      <DivisaoDoPerfil sessao={sessao} />
      <BadgesDoPerfil sessao={sessao} />
      <ColecaoNoPerfil sessao={sessao} perfil={perfil} />
      <PasseNoPerfil />
      <TriosDoPerfil sessao={sessao} />
      {msg && <p className="ok" role="status">{msg}</p>}
      {perfil.cidadeRevisar && !msg && (
        <p className="aviso-cidade" role="status">Sua cidade não bateu com a lista do IBGE. Escolha a cidade de novo para aparecer no ranking da sua região.</p>
      )}
      <section id="editar-perfil" className="editar-perfil" aria-label="Editar perfil">
        <h2 className="rotulo">EDITAR PERFIL</h2>
        <FormPerfil inicial={perfil} sessao={sessao} local botao="SALVAR" ocupado={ocupado} aoSalvar={async (p) => {
          setOcupado(true); setMsg(null);
          try { await conta.salvarPerfil(sessao, p); avisarPerfilCompleto(sessao, p); aoSalvar(p); setMsg('Perfil salvo.'); } finally { setOcupado(false); }
        }} />
      </section>
      <ChaveWhatsapp sessao={sessao} />
      <Gritos sessao={sessao} perfil={perfil} aoMudar={aoSalvar} />
      <ContaEJogo sessao={sessao} perfil={perfil} />
      {erro && <p className="erro" role="alert">{erro}</p>}
      {/* Sair e Excluir ficam por último, depois de Conta e Jogo. */}
      <div className="cartao">
        {confirmar === null && (
          <div className="dupla">
            <button className="btn2" onClick={() => setConfirmar('sair')}>Sair da conta</button>
            <button className="btn2 perigo" onClick={() => setConfirmar('excluir')}>Excluir conta</button>
          </div>
        )}
        {confirmar === 'sair' && (
          <>
            <p>Você entra de novo com o Google quando quiser.</p>
            <div className="dupla">
              <button className="btn2" onClick={() => setConfirmar(null)}>Ficar</button>
              <button className="btn2 perigo" onClick={() => acao(async () => { medir('logout'); await conta.sair(); })}>Sair</button>
            </div>
          </>
        )}
        {confirmar === 'excluir' && (
          <>
            <p>Isso apaga sua conta, seu perfil e sua foto. Não tem volta.</p>
            <div className="dupla">
              <button className="btn2" onClick={() => setConfirmar(null)}>Cancelar</button>
              <button className="btn2 perigo" onClick={() => acao(async () => { await conta.excluirConta(); medir('excluir_conta'); })}>Excluir para sempre</button>
            </div>
          </>
        )}
      </div>
      </div>
      </div>
    </Tela>
  );
}

// A lista no fim do perfil (canvas F15b).
function ContaEJogo({ sessao, perfil }: { sessao: Sessao; perfil: PerfilConta }) {
  const google = true, gratis = perfil.plano === 'gratis';
  void sessao;
  return (
    <nav className="conta-e-jogo" aria-label="Conta e jogo">
      <h2 className="rotulo">CONTA</h2>
      <div className="lista-conta">
        <button className="linha-plano" onClick={() => ir(gratis ? { tela: 'planos', plano: 'prata', ciclo: 'mensal' } : { tela: 'meu-plano' })}>
          <Moeda plano={gratis ? 'prata' : perfil.plano} tamanho={36} />
          {gratis
            ? <span><b>Planos</b><small>Regras da casa e seus gritos, a partir de {precoEmReais('prata')}/mês</small></span>
            : <span><b>Meu plano</b><small>Plano {NOME_DO_PLANO[perfil.plano]}</small></span>}
          <Icone nome="seta" tamanho={18} />
        </button>
        {google && (
          <button className="linha-plano" onClick={() => ir({ tela: 'indique' })}>
            <span className="emoji-linha" aria-hidden="true">🎁</span>
            <span><b>Indique e ganhe</b><small>+{BONUS_POR_INDICACAO} partidas por amigo que criar conta</small></span>
            <Icone nome="seta" tamanho={18} />
          </button>
        )}
        {google && <TentosDoPerfil sessao={sessao} />}
      </div>
      <h2 className="rotulo">JOGO</h2>
      <div className="lista-conta">
        <button className="linha-plano" onClick={() => ir({ tela: 'como-jogar' })}>
          <span className="emoji-linha" aria-hidden="true">🃏</span>
          <span><b>Como jogar</b><small>Regras da mesa, sinais e mão de onze</small></span>
          <Icone nome="seta" tamanho={18} />
        </button>
        {google && (
          <button className="linha-plano" onClick={() => ir({ tela: 'trios' })}>
            <span className="emoji-linha" aria-hidden="true">👥</span>
            <span><b>Trios fixos</b><small>Monte seu trio e some pontos de trio no ranking</small></span>
            <Icone nome="seta" tamanho={18} />
          </button>
        )}
        <button className="linha-plano" onClick={() => ir({ tela: 'marcador' })}>
          <span className="emoji-linha" aria-hidden="true">📋</span>
          <span><b>Marcador do truco no bar</b><small>Placar ao vivo no celular da mesa toda, com QR code e modo telão</small></span>
          <Icone nome="seta" tamanho={18} />
        </button>
        <button className="linha-plano" onClick={() => ir({ tela: 'configuracoes' })}>
          <span className="emoji-linha" aria-hidden="true">⚙️</span>
          <span><b>Configurações</b><small>Notificações, privacidade e bloqueados</small></span>
          <Icone nome="seta" tamanho={18} />
        </button>
      </div>
      <button className="btn2 largo" onClick={() => ir({ tela: 'termos' })}>Termos e privacidade</button>
    </nav>
  );
}

// Editar perfil desce até o formulário; Compartilhar perfil manda o link /jogador/ID (ou copia, sem o menu do aparelho).
function AcoesDoSeuPerfil({ sessao }: { sessao: Sessao }) {
  async function compartilhar() {
    const url = `${location.origin}/jogador/${sessao.id}`;
    try {
      if (navigator.share) { await navigator.share({ title: 'Meu perfil no Truco de 6', url }); return; }
      await navigator.clipboard.writeText(url);
      avisarNaTela('Link do perfil copiado.');
    } catch { /* cancelou o menu de compartilhar */ }
  }
  return (
    <div className="acoes-perfil">
      <button className="btn2" onClick={() => {
        const f = document.getElementById('editar-perfil');
        f?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        f?.querySelector('input')?.focus({ preventScroll: true });
      }}>Editar perfil</button>
      <button className="btn2" onClick={() => void compartilhar()}>Compartilhar perfil</button>
    </div>
  );
}

// Tentos: abre a tela de Tentos (saldo, loja e extrato), com o saldo na linha.
function TentosDoPerfil({ sessao }: { sessao: Sessao }) {
  const { painel } = usePainelTentos(sessao);
  return (
    <button className="linha-plano" onClick={() => ir({ tela: 'loja' })}>
      <Tento tamanho={36} brilho />
      <span><b>Tentos</b><small>{painel ? `Saldo ${painel.saldo}, extrato e loja` : 'Saldo, extrato e loja'}</small></span>
      <Icone nome="seta" tamanho={18} />
    </button>
  );
}
